import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';

import Login from '../Login';
import Home from '../Home';

const App = ({ user, loading }) => {
  if (loading) { return <div>Завантаження</div>; }

  return (
    <Switch>
      <Route path='/login' render={() => <Login user={user} />} />
      <Route
        path='/'
        render={({ match }) => (user ? <Home match={match} user={user} /> : <Redirect to="/login" />)}
      />
    </Switch>
  );
};

App.propTypes = {
  user: PropTypes.object,
  loading: PropTypes.bool.isRequired
};

App.defaultProps = {
  user: undefined
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App/component.js